module.exports = __webpack_public_path__ + "img/whatsapp-bkgd.6da7d68f.jpg";